/* projects/wtaf/src/app/features/widgets/brand-scheduler-report-widget/brand-scheduler-report-widget.component.css */
.widget-subtitle {
  font-size: 12px;
  color: #6c757d;
}
.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 4px;
}
.error-msg {
  color: #db3b21;
  font-size: 13px;
  font-weight: 500;
}
.no-record {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
}
.pass-text {
  color: #1aaa55;
  font-weight: 600;
}
.fail-text {
  color: #db3b21;
  font-weight: 600;
}
.skip-text {
  color: #5b54c7;
  font-weight: 600;
}
.user-filter-dropdown {
  position: relative;
  width: 100%;
}
.user-filter-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1050;
  background-color: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  margin-top: 2px;
  padding: 8px 12px;
  max-height: 250px;
  overflow-y: auto;
}
.user-filter-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.user-filter-actions {
  padding-bottom: 6px;
  margin-bottom: 6px;
  border-bottom: 1px solid #e9ecef;
}
.user-filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  cursor: pointer;
}
/*# sourceMappingURL=brand-scheduler-report-widget.component.css.map */
